export const sideMenu = [
	{
		id: 1,
		title: "My booking",
		subMenu: [
			{
				id: 2,
				title: "Manage my booking",
				url: "/bookings",
				type: "internal",
			},
			{
				id: 3,
				title: "FAQs",
				url: process.env.REACT_APP_FAQS_URL,
				type: "external",
			},
		],
	},
	{
		id: 5,
		title: "Company",
		subMenu: [
			{
				id: 6,
				title: "About Us",
				url: "/about-us",
				type: "managed",
			},
			{
				id: 7,
				title: "How it works",
				url: "/how-it-works",
				type: "managed",
			},
			{
				id: 8,
				title: "Testimonials",
				url: "/testimonials",
				type: "managed",
			},
			{
				id: 9,
				title: "Privacy Policy",
				url: "/privacy-policy",
				type: "managed",
			},
			{
				id: 10,
				title: "Terms and conditions",
				url: "/terms-conditions",
				type: "managed",
			},
		],
	},
	{
		id: 11,
		title: "Connect",
		subMenu: [
			{
				id: 12,
				title: "Tiktok",
				url: "https://www.tiktok.com/@paylatertravel",
				type: "external",
				icon: "tiktok_icon.svg",
			},
			{
				id: 13,
				title: "Facebook",
				url: "https://www.facebook.com/paylatertravel/",
				type: "external",
				icon: "facebook_icon.svg",
			},
			{
				id: 14,
				title: "Instagram",
				url: "https://www.instagram.com/paylatertravel/",
				type: "external",
				icon: "instagram_icon.svg",
			},
		],
	},
];
